export default {
      id: "hands-meet-usage",
      viewBox: "0 0 33 33",
      url: __webpack_public_path__ + "sprite.svg#hands-meet",
      toString: function () {
        return this.url;
      }
    }